angular.module('app').controller('ImportSubjectsCtrl', function($mdToast, $mdDialog, Upload) {
    "ngInject";

    var main = this;
    main.showPreview = false;
    main.previewData = [];
    main.previewColumns = [];
    // Extra matching options; any combination can be enabled.
    main.match_modes = {
        users: false,
        id_number: false
    };

    // The enabled options as a list, in the shape the backend expects.
    main.matchModesList = function() {
        return Object.keys(main.match_modes).filter(function(mode) {
            return main.match_modes[mode];
        });
    };

    // The school is only used for ID-number matching.
    main.schoolId = function() {
        return (main.match_modes.id_number && main.match_school) ? main.match_school.id : null;
    };

    main.uploadFile = function(file) {
        main.selectedFile = file;
    };

    main.dialog = $mdDialog;

    // Remember each row's server-computed default "Contact Is Parent" value so
    // the bulk edit can reset back to it.
    main.storeIsParentDefaults = function() {
        main.previewData.forEach(function(row) {
            if (row.values) {
                row.default_is_parent = row.values.contact_is_parent;
            }
        });
    };

    // Set the "Contact Is Parent" value for every previewed row at once.
    main.setAllIsParent = function(value) {
        main.previewData.forEach(function(row) {
            if (row.values) {
                row.values.contact_is_parent = value;
            }
        });
    };

    // Restore each row's "Contact Is Parent" value to its computed default.
    main.resetIsParent = function() {
        main.previewData.forEach(function(row) {
            if (row.values) {
                row.values.contact_is_parent = row.default_is_parent;
            }
        });
    };

    // Turn a raw column name (e.g. "contact_first_name" or "Favorite Color_id_5")
    // into a readable header label.
    main.columnLabel = function(column) {
        return column
            .replace(/_id_\d+$/, '')
            .replace(/_/g, ' ')
            .replace(/\b\w/g, function(c) { return c.toUpperCase(); });
    };

    main.preview = function() {
        if (!main.selectedFile) {
            var alert = $mdToast.simple().textContent("Please select a file");
            $mdToast.show(alert);
            return;
        }

        if (!main.event) {
            var alert = $mdToast.simple().textContent("Please select an event");
            $mdToast.show(alert);
            return;
        }

        // Auto-populate school from event
        if (!main.match_school && main.event.school) {
            main.match_school = main.event.school;
        }

        main.loading = true;

        Upload.upload({
            method: 'POST',
            url: '/api/v1/admin/event/' + main.event.id + '/subject_signups/preview',
            data: {
                file: main.selectedFile,
                match_modes: JSON.stringify(main.matchModesList()),
                school_id: main.schoolId()
            }
        }).then(function(response) {
            main.previewData = response.data.preview;
            main.previewColumns = response.data.columns;
            main.storeIsParentDefaults();
            main.showPreview = true;
            main.loading = false;
        }, function(error) {
            var errorMsg = error.data && error.data.message ? error.data.message : 'Error parsing CSV';
            var alert = $mdToast.simple().textContent(errorMsg);
            $mdToast.show(alert);
            main.loading = false;
        });
    };

    main.refreshPreview = function() {
        if (!main.showPreview || !main.selectedFile) {
            return;
        }

        main.loading = true;

        Upload.upload({
            method: 'POST',
            url: '/api/v1/admin/event/' + main.event.id + '/subject_signups/preview',
            data: {
                file: main.selectedFile,
                match_modes: JSON.stringify(main.matchModesList()),
                school_id: main.schoolId()
            }
        }).then(function(response) {
            main.previewData = response.data.preview;
            main.previewColumns = response.data.columns;
            main.storeIsParentDefaults();
            main.loading = false;
        }, function(error) {
            var errorMsg = error.data && error.data.message ? error.data.message : 'Error refreshing preview';
            var alert = $mdToast.simple().textContent(errorMsg);
            $mdToast.show(alert);
            main.loading = false;
        });
    };

    main.backToUpload = function() {
        main.showPreview = false;
        main.previewData = [];
        main.previewColumns = [];
    };

    main.save = function() {

        if(!main.selectedFile) {
            var alert = $mdToast.simple().textContent("Please select a file");
            $mdToast.show(alert);
            return;
        }

        if(main.loading) {
            var alert = $mdToast.simple().textContent("Import already in progress");
            $mdToast.show(alert);
            return;
        }

        var selected = [];
        var isParent = [];
        main.previewData.forEach(function(row, index) {
            if (row.import) {
                selected.push(index);
            }
            isParent.push(row.values ? row.values.contact_is_parent : null);
        });

        if (!selected.length) {
            var alert = $mdToast.simple().textContent("Please select at least one row to import");
            $mdToast.show(alert);
            return;
        }

        main.loading = true;

        Upload.upload({
            'method': 'POST',
            'url': '/api/v1/admin/event/' + main.event.id + '/subject_signups/import',
            'data': {
                'file': main.selectedFile,
                'event_id': main.event.id,
                'selected': JSON.stringify(selected),
                'is_parent': JSON.stringify(isParent),
                'match_modes': JSON.stringify(main.matchModesList()),
                'school_id': main.schoolId()
            }
        }).then(function(response) {
            var alert = $mdToast.simple().textContent(response.data.message);
            $mdToast.show(alert);
            $mdDialog.hide();
        },
            function(error) {
                main.loading = false;
                main.selectedFile = null;
                var errorMsg = error.data && error.data.message ? error.data.message : 'Import failed';
                var alert = $mdToast.simple().textContent(errorMsg);
                $mdToast.show(alert);
            }
        );
    };
});
